import React, { ReactElement } from 'react';
import { ThemeProvider } from 'emotion-theming';

import {
  AlertMessageBox,
  Content,
  Header,
  IconColumn,
  StyledIcon,
  TextColumn,
} from './styles';
import { ALERT_MESSAGE_ICONS, ALERT_MESSAGE_STYLES } from './constants';
import { AlertMessageType } from './types';

export interface AlertMessageProps {
  kind: AlertMessageType;
  title?: string;
  message: string | ReactElement;
  inContent?: boolean;
  className?: string; // for styled component
}

export const AlertMessage = React.memo(
  ({
    kind,
    title,
    message,
    inContent = false,
    className,
  }: AlertMessageProps) => {
    return (
      <ThemeProvider theme={ALERT_MESSAGE_STYLES[kind]}>
        <AlertMessageBox inContent={inContent} className={className}>
          <IconColumn>
            <StyledIcon icon={ALERT_MESSAGE_ICONS[kind]} />
          </IconColumn>
          <TextColumn>
            {title && <Header>{title}</Header>}
            {message && <Content hasHeader={!!title}>{message}</Content>}
          </TextColumn>
        </AlertMessageBox>
      </ThemeProvider>
    );
  }
);
